<template>
    <div>
        <BookingBack title='Gift Card' :textColor="'#333333'" :isCenter="true"/>

        <div class="cards">
          <div v-for="item in cardList" :key="item.id">
            <GiftCardPreview :cardData="item"/>
          </div>
        </div>

    </div>
</template>
<script>
import BookingBack from '@/components/Booking/back.vue'
import GiftCardPreview from '@/components/GiftCard/PreviewCard.vue'
import { getSupplierCard } from '@/api/index.js'
export default {
    name:'GiftCard',
    data(){
        return {
            cardList: [],
            shop_supplier_id: this.$route.query.shop_supplier_id || '',
            page: 1,
            list_rows: 10
        }
    },
    components:{
        BookingBack,
        GiftCardPreview
    },
    created(){
        this.getCardList()
    },
    methods:{
        async getCardList(){
            const res = await getSupplierCard({
                shop_supplier_id: this.shop_supplier_id,
                page: this.page,
                list_rows: this.list_rows
            })
            if(res.code == 1){
                this.cardList = res.data.list.data || []
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.back-btn {
    width: 1.5rem;
    height: 2.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
        width: 1.5rem;
        height: 1.5rem;
    }
}
.cards {
    width: 100%;
    padding: 1rem;
    box-sizing: border-box;
}
</style>
